import { render, staticRenderFns } from "./S12Ui.vue?vue&type=template&id=5a9d17b4&scoped=true"
import script from "./S12Ui.vue?vue&type=script&lang=js"
export * from "./S12Ui.vue?vue&type=script&lang=js"
import style0 from "./S12Ui.vue?vue&type=style&index=0&id=5a9d17b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9d17b4",
  null
  
)

export default component.exports